export enum MARITAL_STATUS {
  married = 'married',
  notMarried = 'notMarried'
}

export enum LIVING_TOGETHER {
  livingTogether = 'livingTogether',
  notLivingTogether = 'notLivingTogether'
}
